module.exports = __webpack_public_path__ + "static/media/edc-engineering-design-consultants-limited.41f07b21.png";